/** Three twinkling four-point stars — the visual signature of every AI feature on the site. */
export const AiSparkle = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path className="ai-star" fill="#D4A72C" d="M10 2l1.6 5.4L17 9l-5.4 1.6L10 16l-1.6-5.4L3 9l5.4-1.6z" />
    <path className="ai-star" fill="#8B1A1A" d="M18.5 13l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9z" />
    <path className="ai-star" fill="#1B3A8C" d="M18 2.5l.6 1.9 1.9.6-1.9.6-.6 1.9-.6-1.9-1.9-.6 1.9-.6z" />
  </svg>
);

/** Small pill marking AI features. */
export const AiBadge = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-1 rounded-full bg-ink px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-white ${className}`}>
    <AiSparkle className="h-3 w-3" /> AI
  </span>
);
